module.exports = __webpack_public_path__ + "static/1-e37f5b7810d12df4f80befb6d9112ae5.jpg";